import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'iad-error403-blocked-agent',
  templateUrl: './error403-blocked-agent.component.html',
  styleUrls: ['./error403-blocked-agent.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Error403BlockedAgentComponent {
}
